export const selectGoalFromGlobalGoals = (goalId) => (state) => state.globalGoals?.[goalId]?.data;

export const selectGoalAndMetadataFromGlobalGoals = (goalId) => (state) => state.globalGoals?.[goalId];
